import React from "react";
import {SvgIconProps} from "@material-ui/core/SvgIcon";

const IncludePackageIcon = (props: SvgIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_42984_166325)">
        <path
          d="M13.65 1.5H2.85C2.175 1.5 1.5 2.1075 1.5 2.85V4.88175C1.5 5.36775 1.79025 5.78625 2.175 6.0225V13.65C2.175 14.3925 2.9175 15 3.525 15H12.975C13.5825 15 14.325 14.3925 14.325 13.65V6.0225C14.7098 5.78625 15 5.36775 15 4.88175V2.85C15 2.1075 14.325 1.5 13.65 1.5ZM10.275 9.6H6.225V8.25H10.275V9.6ZM13.65 4.875H2.85V2.85L13.65 2.8365V4.875Z"
          fill={props.htmlColor || "#2979FF"}
        />
        <circle cx="12.75" cy="12.75" r="3.75" fill="#E9F0FA" />
        <path
          d="M10.5 12.1875V13.3125H12.1875V15H13.3125V13.3125H15V12.1875H13.3125V10.5H12.1875V12.1875H10.5Z"
          fill={props.htmlColor || "#2979FF"}
        />
      </g>
      <defs>
        <clipPath id="clip0_42984_166325">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IncludePackageIcon;
